// import React, { useState } from 'react'
// import { DashboardHeader, Sidebar } from '../../Layout.Components'

// const DashboardLayout = ({ children, path }) => {

//     const [hamburgerMenu, setHamburgerMenu] = useState(true)

//     return (
//         <div className='w-full h-screen overflow-hidden flex '>
//             {/* Sidebar with Dynamic Width and Slide Animation */}
//             <div className={`transition-all duration-300 ${hamburgerMenu ? 'w-[180px]' : 'w-[0px] -translate-x-full overflow-hidden'}`}>
//                 <Sidebar />
//             </div>

//             {/* Main Dashboard Area Adjusting Width Automatically */}
//             <div className={`flex-1 w-[calc(100vw-180px)] flex flex-col transition-all duration-300 ${hamburgerMenu ? 'ml-0' : 'ml-0'}`}>
//                 {/* Header Section */}
//                 <div className='w-full bg-blue-950 text-[12px] h-[55px]'>
//                     <DashboardHeader setHamburgerMenu={setHamburgerMenu} hamburgerMenu={hamburgerMenu} />
//                 </div>

//                 {/* Main Content Section */}
//                 <div className='w-full h-[calc(100vh-55px)] overflow-scroll no-scrollbar'>
//                     {children}
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default DashboardLayout

import React, { useState } from 'react'
import { DashboardHeader, Sidebar } from '../../Layout.Components'

const DashboardLayout = ({ children, path }) => {

    const [hamburgerMenu, setHamburgerMenu] = useState(true)

    return (
        <div className='w-full h-screen overflow-hidden flex '>
            {/* Sidebar with Dynamic Width and Slide Animation */}
            <div className={`transition-all duration-300 ${hamburgerMenu ? 'w-[180px]' : 'w-[0px] -translate-x-full overflow-hidden'}`}>
                <Sidebar />
            </div>

            {/* Main Dashboard Area Adjusting Width Automatically */}
            <div className={`flex-1 w-[calc(100vw-180px)] flex flex-col transition-all duration-300 ${hamburgerMenu ? 'ml-0' : 'ml-0'}`}>
                {/* Header Section */}
                <div className='w-full bg-blue-950 text-[12px] h-[55px]'>
                    <DashboardHeader setHamburgerMenu={setHamburgerMenu} hamburgerMenu={hamburgerMenu} />
                </div>

                {/* Main Content Section */}
                <div className='w-full h-[calc(100vh-55px)] overflow-scroll no-scrollbar'>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default DashboardLayout
